export default __webpack_public_path__ + "static/media/accounts.f5a3a150.jpg";